import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CHATTER_LESSON_EDIT, CHATTER_LESSON_LIST } from "config/paths";
import { useChatterLessonDetailsQuery } from "store/services/chatter/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import parse from "html-react-parser";

const ChatterLessonDetail = () => {

  const { id: lessonId } = useParams();
  const navigate = useNavigate();

  const { data: lessonDetails, isLoading } = useChatterLessonDetailsQuery(lessonId);

  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          <Row>
            <Col
              lg="12"
              className=""
              style={{ borderRight: "1px solid #3da0aa4f" }}
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold back-to-btn"
                            to={CHATTER_LESSON_LIST}
                          >
                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                            </svg> Back
                          </Link>
                        </li>
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold"
                            style={{ textDecoration: "underline" }}
                            to={CHATTER_LESSON_LIST}
                          >
                            Chatter Lesson
                          </Link>
                        </li>
                        <li className="">
                          <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                        </li>
                      </ul>
                    </div>
                    <div className="right">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                        <li className="">
                          <Button
                            className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                            variant="outline-success"
                            onClick={() => navigate(CHATTER_LESSON_EDIT.replace(":id", lessonId))}
                          >
                            <span className="icn me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <mask
                                  id="mask0_0_2439"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_0_2439)">
                                  <path
                                    d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                    fill="currentColor"
                                  />
                                </g>
                              </svg>
                            </span>
                            Edit
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                {
                  isLoading ? <LoadingIndicator /> :
                    <Col lg="12" className="my-3">
                      <div className="top d-flex align-items-center gap-10">
                        <div
                          className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                          style={{ height: 35, width: 35, background: "#DBDBDB" }}
                        >
                          {lessonDetails?.title[0]?.toUpperCase() || ""}
                        </div>
                        <div className="content">
                          <h6 className="m-0 themeBlue fw-sbold">{lessonDetails?.title || "--"}</h6>
                        </div>
                      </div>
                      <Row>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Title
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{lessonDetails?.title || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Tag
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{lessonDetails?.tag || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Status
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{lessonDetails?.status || "--"}</p>
                          </div>
                        </Col>
                        <Col md="5" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Files
                            </h6>
                            <ul>
                              {
                                lessonDetails?.files?.map((item, index) => {
                                  return (<li><p key={index} className="m-0 forteen themeBlue pt-2">{item?.attachment_name || "--"}</p></li>)
                                })
                              }
                            </ul>

                          </div>
                        </Col>
                        <Col lg="12" className="my-3">
                          <h6 className="m-0 themeBlue fw-sbold">Description</h6>
                          <p className="m-0 forteen themeBlue">
                            {lessonDetails?.description ? parse(lessonDetails?.description) : "--"}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                }
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterLessonDetail;
